import { joinClasses } from '../../primitives/fieldClassSlots';
import { layoutInlineStyle } from '../layoutInlineStyle';
import type { LayoutNodeChildProps } from '../nodeRenderProps';
import type { FieldRowNode } from '../types';
import { RenderNodes } from '../renderNodes';

export function FieldRow({
  node,
  answers,
  repeatBindings,
}: LayoutNodeChildProps<FieldRowNode>) {
  const gap = node.gap ?? 2;
  const rowDefault =
    'flex min-w-0 flex-row max-md:flex-wrap items-center gap-3';
  return (
    <div
      className={joinClasses('min-w-0', node.className)}
      style={layoutInlineStyle(node.style)}
    >
      <div className={`space-y-${gap}`}>
        <div className={joinClasses(node.labelClassName)}>
          <RenderNodes
            nodes={node.label}
            answers={answers}
            repeatBindings={repeatBindings}
          />
        </div>
        <div className={joinClasses(rowDefault, node.rowClassName)}>
          <RenderNodes
            nodes={node.controls}
            answers={answers}
            repeatBindings={repeatBindings}
          />
        </div>
      </div>
    </div>
  );
}
